export var getHoldingsUnit = function (holdingData, symbol, isin) {
    var _a, _b;
    if (holdingData && (holdingData === null || holdingData === void 0 ? void 0 : holdingData.length) > 0) {
        if (isin) {
            return (((_a = holdingData === null || holdingData === void 0 ? void 0 : holdingData.find(function (holding) { var _a; return ((_a = holding === null || holding === void 0 ? void 0 : holding.quote) === null || _a === void 0 ? void 0 : _a.isin) == isin; })) === null || _a === void 0 ? void 0 : _a.quantity) || 0);
        }
        else {
            return (((_b = holdingData === null || holdingData === void 0 ? void 0 : holdingData.find(function (holding) { var _a; return ((_a = holding === null || holding === void 0 ? void 0 : holding.quote) === null || _a === void 0 ? void 0 : _a.symbol) == symbol; })) === null || _b === void 0 ? void 0 : _b.quantity) || 0);
        }
    }
    else {
        return 0;
    }
};
